BookingApp.controller('BusesSearchController',function($scope,$http,$filter,$location,$routeParams){

    $scope.request = $routeParams;
    $scope.request.journeyDate = moment($routeParams.journeyDate, 'YYYYMMDD');


    if($scope.request.JourneyType == 2){
        $scope.request.returnDate = moment($routeParams.returnDate,'YYYYMMDD')
        console.log("condition true")
    }else{
        $scope.request.returnDate = $scope.request.journeyDate.clone();
        $scope.request.returnDate.add(5,'days');
    }


    console.log($scope.request);

    $scope.datePicker   = {
        options : {
            singleDatePicker : $scope.request.JourneyType == 1,
            autoApply:true,
            autoUpdateInput:false
        },
        min: new Date(),
        date : ($scope.request.JourneyType == 1) ? $scope.request.journeyDate : {
                startDate: $scope.request.journeyDate,
                endDate: angular.isDefined($scope.request.returnDate) ? $scope.request.returnDate : null
            }
    }

    $scope.$watch('request["JourneyType"]',function(n,v){
        $scope.datePicker.options.singleDatePicker = $scope.request.JourneyType == 1
        if($scope.request.JourneyType != 1){
            $scope.datePicker.options.autoUpdateInput = true
        }
        $scope.datePicker.date = ($scope.request.JourneyType == 1) ? $scope.request.journeyDate : {
                startDate: $scope.request.journeyDate,
                endDate: angular.isDefined($scope.request.returnDate) ? $scope.request.returnDate : NextDate.clone()
            }
    });


    //Modufy Search section
    $scope.request.travellers = function(){
        return (parseInt($scope.request.adult) + parseInt($scope.request.child));
    }

    $scope.getOrigins = function (val){
        return $http.get('https://' + window.location.hostname + '/buses/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });;
    }

    $scope.getDestination = function(val){
        return $scope.getLocation(val);
    }

    $scope.getLocation = function (val){
        return $http.get('https://' + window.location.hostname + '/buses/suggestion/queries/' + val)
            .then(function(response){
                return response.data.map(function(item){
                    return item;
                });
            });
    }


    $scope.TravellerOpen = false;
    $scope.OpenTravellerPopUp = function(){
        $scope.TravellerOpen = true;
    }
    $scope.closepopup = function(){
        $scope.TravellerOpen = false;
    }

    $scope.searchFlight = function(){
        var request = {};//$scope.request;
        //console.log($scope.request.JourneyType);return;
        if($scope.request.JourneyType == 2 )
        {
            request.startDate = $scope.datePicker.date.startDate.format('YYYYMMDD');
            request.endDate =   $scope.datePicker.date.endDate.format('YYYYMMDD');
            //console.log(request);
            if($scope.datePicker.date.endDate == null) return;
            $('#modifysearch').modal('hide')

            fbq('track', 'Search', {
                search_string: 'bus-from-'+ $scope.request.origin + '-to-' + $scope.request.destination + '-on-' + request.startDate + '-' + request.endDate
            });

            $location.path('buses/search/from-'+ $scope.request.origin + '-to-' + $scope.request.destination + '-on-' + request.startDate + '-' + request.endDate + '-' + $scope.request.JourneyType);
        }
        else
        {
            request.JourneyDate = $scope.datePicker.date.format('YYYYMMDD');
            $('#modifysearch').modal('hide')

            fbq('track', 'Search', {
                search_string: 'bus-from-'+ $scope.request.origin + '-to-' + $scope.request.destination + '-on-' + request.JourneyDate
            });
            $location.path('buses/search/from-'+ $scope.request.origin + '-to-' + $scope.request.destination + '-on-' + request.JourneyDate + '-' + $scope.request.JourneyType);
        }
    }

});
